module.exports = __webpack_public_path__ + "static/media/14c6f1fa-6d85-42fa-b1d5-7b90424f523f.19b3edb9.jpeg";